import { UPDATE_INTERVENTION_SUCCESS } from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';

import * as actionTypes from 'modules/serviceHeaders/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/** @typedef {import('modules/serviceHeaders/types/wrappedServiceHeader').WrappedServiceHeader} ServiceHeaderSelectedReducer */
const initialState = null;

const reset = () => initialState;

/**
 * @param {ServiceHeaderEntriesReducer} _
 * @param {import('modules/serviceHeaders/types/actions').SelectEntryAction} action
 * @returns {ServiceHeaderEntriesReducer}
 */
const afterFetchEntries = (_, { payload }) => payload;

export default createReducer(initialState, {
  [LOCATION_CHANGE]: reset,
  [UPDATE_INTERVENTION_SUCCESS]: reset,
  [actionTypes.FETCH_SERVICE_HEADER]: reset,
  [actionTypes.SELECT_DMS_ENTRY]: afterFetchEntries,
});
